import * as actionTypes from "../actionTypes";

export const getAboutUs = payload => ({
    type: actionTypes.GET_ABOUT_US,
    payload
})

export const setAboutUs = payload => ({
    type: actionTypes.SET_ABOUT_US,
    payload
})

export const createAboutUs = payload => ({
    type: actionTypes.CREATE_ABOUT_US,
    payload
})

export const getTermsAndCondition = payload => ({
    type: actionTypes.GET_TERMS_AND_CONDITION,
    payload
})

export const setTermsAndCondition = payload => ({
    type: actionTypes.SET_TERMS_AND_CONDITION,
    payload
})

export const createTermsAndCondition = payload => ({
    type: actionTypes.CREATE_TERMS_AND_CONDITION,
    payload
})

export const getPrivacyPolicy = payload => ({
    type: actionTypes.GET_PRIVACY_POLICY,
    payload
})

export const setPrivacyPolicy = payload => ({
    type: actionTypes.SET_PRIVACY_POLICY,
    payload
})

export const createPrivacyPolicy = payload => ({
    type: actionTypes.CREATE_PRIVACY_POLICY,
    payload
})

export const getRefundPolicy = payload => ({
    type: actionTypes.GET_REFUND_POLICY,
    payload
})

export const setRefundPolicy = payload => ({
    type: actionTypes.SET_REFUND_POLICY,
    payload
})

export const createRefundPolicy = payload => ({
    type: actionTypes.CREATE_REFUND_POLICY,
    payload
})

// export const createCookiesPolicy = payload => ({
//     type: actionTypes.CREATE_COOKIES_POLICY,
//     payload
// })